let Wsc = function (wssUrl, options) {
    let that = this;

    if (!("WebSocket" in window)) throw "WebSocket NOT supported by your Browser!";

    if (!wssUrl) throw "WebSocket server url is empty!";

    that.client = null;
    that.isConnected = false;
    that.options = Object.assign({}, options);
    that.disposed = false;

    // that.options
    let cb_open = that.options.open;
    let cb_receive = that.options.receive;
    let cb_close = that.options.close;

    // 이 클래스는 순수 transport(연결/전송/종료)만 책임진다.
    // "언제 재연결할지"(폴백 타이머·탭 가시성 등)는 정책이므로 사용처(PageSocket)가 관장한다.
    that.start = () => {
        if (that.client !== null) return that;

        that.client = null; // 이전 소켓 정리
        that.client = new WebSocket(wssUrl);
        that.client.onopen = function () {
            that.isConnected = true;
            //console.log("WebSocket opened..");

            if (cb_open) cb_open(that);
        };
        that.client.onclose = function () {
            that.isConnected = false;
            console.log("WebSocket closed...");

            that.client = null; // 이전 소켓 정리

            if (cb_close) cb_close(that);
        };

        that.client.onmessage = function (evt) {
            try {
                // console.log("WebSocket receivedMsg", evt.data); // , evt.data);
                if (that.disposed) return;
                if (cb_receive) cb_receive(evt);
            } catch (err) {
                console.error("WebSocket onmessage error", err);
            }
        };

        that.client.onerror = function (evt) {
            const errorMsg = evt.message || evt.type || "Unknown error";
            const isCertError =
                errorMsg.includes("CERT") || errorMsg.includes("certificate") || errorMsg.includes("ERR_CERT");

            if (isCertError && process.env.NODE_ENV !== "production") {
                console.warn(
                    "WebSocket certificate error (개발 환경):",
                    "\n브라우저에서 다음 URL에 접속하여 인증서를 신뢰하도록 설정하세요:",
                    `\n${wssUrl}`,
                    "\n또는 Chrome에서 인증서 경고 화면에서 'thisisunsafe'를 입력하세요.",
                );
            } else {
                console.error("WebSocket error", evt);
            }
        };
        // console.log(that);

        return that;
    };

    that.send = (msg) => {
        if (that.client) that.client.send(typeof msg == "object" ? JSON.stringify(msg) : msg);
    };

    /**
     * 내부 소켓이 실제로 OPEN 상태인지 반환한다.
     * isConnected 플래그는 onclose 지연(iOS Safari 등)으로 stale 할 수 있으므로,
     * 재연결 판단은 추정 플래그가 아니라 실제 readyState 로 한다.
     * @returns {boolean}
     */
    that.isAlive = () => that.client !== null && that.client.readyState === WebSocket.OPEN;

    /**
     * 죽은(또는 readyState 만 OPEN 인 좀비) 소켓을 강제로 정리하고 새로 연결한다.
     * 지연 발화될 수 있는 옛 소켓의 핸들러를 떼어내, 새 연결 직후 상태가 뒤집히는 것을 막는다.
     * @returns {void}
     */
    that.forceReconnect = () => {
        if (that.client) {
            that.client.onopen = null;
            that.client.onclose = null;
            that.client.onmessage = null;
            that.client.onerror = null;
            try {
                that.client.close();
            } catch (err) {
                console.warn("WebSocket forceReconnect close error", err);
            }
        }
        that.client = null; // 이전 소켓 정리
        that.isConnected = false;
        that.start();
    };

    that.destroy = () => {
        console.log("WebSocket destroy");

        that.disposed = true;
        if (that.client) that.client.close();
        that.client = null; // 이전 소켓 정리
    };
};

export default Wsc;
